const AboutContent = () => {
  const milestones = [
    { year: "2024", title: "Company Founded", description: "Started with a vision to transform business technology" },
    { year: "2024", title: "First Major Client", description: "Website and web applications for small business" },
    { year: "2025", title: "Expansion", description: "Lauched the MVP for tally ride and Developed an EDMS(Electronic document management system)" },
    { year: "2025", title: "AI Division Launch", description: "Deployed AI enhanced EDMS to ministries and parastatals to automate their process and enhance record keeping" },
    { year: "2025", title: "15+ Employees", description: "Launched DownloadChow our Flagship product in FoodTech with success record of over 3000 users as at Dec 2025" },
  ];

  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-4xl font-bold mb-6">Our Story</h2>
            <p className="text-gray-600 mb-4">
              Founded in 2024, Tally Technologies began as a small startup with a big vision: 
              to make cutting-edge technology accessible to businesses of all sizes.
            </p>
            <p className="text-gray-600 mb-4">
              Today, we're a leader in business technology solutions, serving clients 
              in Nigeria with innovative products and services that drive real results.
            </p>
            <p className="text-gray-600">
              Our team of experts combines deep industry knowledge with technical 
              excellence to deliver solutions that matter.
            </p>
          </div>
          <div className="bg-gradient-to-br from-primary-50 to-gray-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold mb-6">Our Values</h3>
            <div className="space-y-6">
              {[
                { title: "Innovation", desc: "Constantly pushing boundaries" },
                { title: "Integrity", desc: "Honest and transparent partnerships" },
                { title: "Excellence", desc: "Striving for perfection in everything" },
                { title: "Collaboration", desc: "Working together for success" },
              ].map((value, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-primary-700 font-bold">{index + 1}</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-1">{value.title}</h4>
                    <p className="text-gray-600">{value.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Milestones */}
        <div className="relative">
          <h2 className="text-4xl font-bold text-center mb-12">Our Journey</h2>
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-primary-400 to-primary-600"></div>
            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div key={index} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                  <div className={`w-1/2 ${index % 2 === 0 ? 'pr-12 text-right' : 'pl-12'}`}>
                    <div className="bg-white p-6 rounded-xl shadow-lg">
                      <div className="text-primary-600 font-bold text-lg mb-2">{milestone.year}</div>
                      <h3 className="text-xl font-bold mb-2">{milestone.title}</h3>
                      <p className="text-gray-600">{milestone.description}</p>
                    </div>
                  </div>
                  <div className="relative z-10">
                    <div className="w-6 h-6 bg-primary-600 rounded-full border-4 border-white"></div>
                  </div>
                  <div className="w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutContent;